import React, { useEffect } from "react";
import { Box, Container, Skeleton, Stack, Typography } from "@mui/material";
import PropertySlider from "../../../../Components/PropertySlider/PropertySlider";
import PropertyCard from "../../../../Components/PropertyCard/PropertyCard";
import {
  useLazyGetRecentlyAddedPropertyQuery,
} from "../../../../Services/auto-complete.services";
import { RightPaddingWrapper } from "../../../../Components/RightPaddingWrapper/RightPaddingWrapper";
import { useSelector } from "react-redux";

const RecentlyAdded = () => {
  const selectedRecentlyAdded =
    useSelector((state: any) => state?.propertyReducer?.recentlyAddedProperties) ||
    null;
  const locationBased =
    useSelector((state: any) => state?.propertyReducer?.locationBased) || null;

  const [trigger, { isLoading }] =
    useLazyGetRecentlyAddedPropertyQuery();

  useEffect(() => {
    trigger({});
  }, [trigger]);

  if (isLoading || !selectedRecentlyAdded) {
    return (
      <Container maxWidth={"xl"} disableGutters>
        <RightPaddingWrapper>
          <Stack direction={"column"} spacing={"30px"}>
            <Box>
              <Skeleton animation="wave" variant="text" width={280} height={40} />
            </Box>
            <Stack direction={"row"} gap={"10px"} sx={{ overflow: "hidden" }}>
              {Array.from(new Array(4)).map((v: any, i: any) => (
                <Box
                  key={i}
                  sx={{
                    minWidth: { xs: "280px", sm: "300px", md: "320px" },
                    borderRadius: "15px",
                    overflow: "hidden",
                  }}
                >
                  <Stack direction={"column"} height={"100%"} overflow={"hidden"}>
                    <Skeleton
                      animation="wave"
                      variant="rectangular"
                      sx={{
                        width: "100%",
                        height: { xs: "240px", md: "250px", lg: "260px", xl: "275px" },
                        borderRadius: "15px",
                      }}
                    />
                    <Box p={"25px"}>
                      <Stack direction={"column"} spacing={1}>
                        <Skeleton animation="wave" width="80%" height={28} />
                        <Skeleton animation="wave" width="60%" height={24} />
                        <Skeleton animation="wave" width="70%" height={20} />
                      </Stack>
                    </Box>
                  </Stack>
                </Box>
              ))}
            </Stack>
          </Stack>
        </RightPaddingWrapper>
      </Container>
    );
  }

  // Only for-sale homes — never surface claimed homes (those stay locked).
  const forSale = (selectedRecentlyAdded?.results || []).filter((v: any) => !v?.isClaimed);
  const locationLabel =
    forSale?.[0]?.address?.city || locationBased?.data?.stateDetails?.stateName || "";
  const heading = locationLabel ? `Homes for Sale in ${locationLabel}` : "Homes for Sale Near You";

  if (forSale.length === 0) {
    return <></>;
  }

  return (
    <Container maxWidth={"xl"} disableGutters>
      <RightPaddingWrapper>
        <Stack direction={"column"} spacing={"30px"}>
          <Box>
            <Typography variant="h4" fontWeight={700}>
              {heading}
            </Typography>
          </Box>
          <Box>
            <PropertySlider>
              {forSale.map((v: any, i: any) => (
                <PropertyCard
                  key={i}
                  type="recently"
                  id={v?.propertyRefID}
                  propertyId={v?.propertyId}
                  isClaimed={v?.isClaimed}
                  featuredPhoto={v?.featuredPhoto}
                  mls={v?.mls}
                  propertyName={v?.address?.address}
                  bathCount={v?.propertyOverView?.bathrooms || "0"}
                  bedCount={v?.propertyOverView?.bedrooms}
                  stateName={v?.address?.state}
                  stateZip={v?.address?.zip}
                  sqrFeet={v?.propertyOverView?.lotSize}
                  // stateId={v?.mailAddress?.stateDetails?.stateID}
                  href={`/${v?.propertyId}/property-id/${v?.propertyId}`}
                  city={v?.address?.city}
                />
              ))}
            </PropertySlider>
          </Box>
        </Stack>
      </RightPaddingWrapper>
    </Container>
  );
};

export default RecentlyAdded;
